import { useSelector } from 'react-redux'
export function useLocks() {
  return {
    locks: useSelector(
      (state) => {
        return state.locks
      },
      (left, right) => JSON.stringify(left) == JSON.stringify(right)
    ),
  }
}
